import {MyopMessages} from "../../common/MyopMessages";
import {ExecuteScriptMessage, ExecuteScriptReplyMessage} from "../../messages";
import {BaseMessageHandler, RootRef} from "../../common";
import {ExecuteScriptHandlerExecutor} from "../../common/messageHandlers/executeScriptHandler.ts";

export class ExecuteScriptHandler extends BaseMessageHandler<ExecuteScriptMessage> {
    messageType = MyopMessages.ExecuteScriptMessage

    executor = (event: ExecuteScriptMessage) => {
        const replier = (data: any) => {
            this.messageToHost(new ExecuteScriptReplyMessage(event.handlerUniqueId, data));
        };

        ExecuteScriptHandlerExecutor(event, replier, new RootRef(document.documentElement));
    }
}
